import type { TFunction } from 'i18next';
import {
  faCalendarDay,
  faGearComplex,
  faLayerGroup,
  faMagnifyingGlass,
  faMessages,
  faPaperPlane,
  faQuestion,
  faRankingStar,
  faShoppingCart,
  faStarHalfStroke,
  faUserGroup,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const tabsSettingsTabIds = [
  'categories',
  'today',
  'settings',
  'community',
  'search',
  'chat',
  'merchmmf',
  'merchwp',
  'voting',
  'leaderboard',
  'submissions',
  'explore',
  'forum',
] as const;
export type ITabsSettingsTabId = (typeof tabsSettingsTabIds)[number];

type ITabsProps = {
  id: string;
  icon: React.ReactNode;
  label: string;
  supportingText?: string;
};

export const getTabProps = (
  id: string,
  t: TFunction<'translation', undefined>,
): ITabsProps => {
  switch (id as ITabsSettingsTabId) {
    case 'categories':
      return {
        id,
        icon: <FontAwesomeIcon icon={faLayerGroup} />,
        label: t('TabsSettingsForm.tabs.categories.label'),
        supportingText: t('TabsSettingsForm.tabs.categories.supportingText'),
      };

    case 'community':
      return {
        id,
        icon: <FontAwesomeIcon icon={faUserGroup} />,
        label: t('TabsSettingsForm.tabs.community.label'),
        supportingText: t('TabsSettingsForm.tabs.community.supportingText'),
      };

    case 'explore':
      return {
        id,
        icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
        label: t('TabsSettingsForm.tabs.explore.label'),
        supportingText: t('TabsSettingsForm.tabs.explore.supportingText'),
      };

    case 'search':
      return {
        id,
        icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
        label: t('TabsSettingsForm.tabs.search.label'),
        supportingText: t('TabsSettingsForm.tabs.search.supportingText'),
      };

    case 'settings':
      return {
        id,
        icon: <FontAwesomeIcon icon={faGearComplex} />,
        label: t('TabsSettingsForm.tabs.settings.label'),
        supportingText: t('TabsSettingsForm.tabs.settings.supportingText'),
      };

    case 'today':
      return {
        id,
        icon: <FontAwesomeIcon icon={faCalendarDay} />,
        label: t('TabsSettingsForm.tabs.today.label'),
        supportingText: t('TabsSettingsForm.tabs.today.supportingText'),
      };

    case 'chat':
      return {
        id,
        icon: <FontAwesomeIcon icon={faMessages} />,
        label: t('TabsSettingsForm.tabs.chat.label'),
        supportingText: t('TabsSettingsForm.tabs.chat.supportingText'),
      };

    case 'merchmmf':
      return {
        id,
        icon: <FontAwesomeIcon icon={faShoppingCart} />,
        label: t('TabsSettingsForm.tabs.merchmmf.label'),
        supportingText: t('TabsSettingsForm.tabs.merchmmf.supportingText'),
      };

    case 'merchwp':
      return {
        id,
        icon: <FontAwesomeIcon icon={faShoppingCart} />,
        label: t('TabsSettingsForm.tabs.merchwp.label'),
        supportingText: t('TabsSettingsForm.tabs.merchwp.supportingText'),
      };

    case 'voting':
      return {
        id,
        icon: <FontAwesomeIcon icon={faStarHalfStroke} />,
        label: t('TabsSettingsForm.tabs.voting.label'),
      };

    case 'leaderboard':
      return {
        id,
        icon: <FontAwesomeIcon icon={faRankingStar} />,
        label: t('TabsSettingsForm.tabs.leaderboard.label'),
      };

    case 'submissions':
      return {
        id,
        icon: <FontAwesomeIcon icon={faPaperPlane} />,
        label: t('TabsSettingsForm.tabs.submissions.label'),
      };

    case 'forum':
      return {
        id,
        icon: <FontAwesomeIcon icon={faUsers} />,
        label: t('TabsSettingsForm.tabs.forum.label'),
      };

    default:
      return {
        id,
        icon: <FontAwesomeIcon icon={faQuestion} />,
        label: t('TabsSettingsForm.tabs.unknown.label', {
          id,
        }),
      };
  }
};
